(function () {
    "use strict";

    angular.module("app").factory("loadingIndicatorService", ServiceFactory);

    ServiceFactory.$inject = ['$rootScope'];
    function ServiceFactory($rootScope) {
        const current = { overlay: true, actionBar: true };
        const OVERLAY_KEY = "isLoadingChanged";
        const ACTION_BAR_KEY = "isPartLoadingChanged";
        const LEGACY_KEY = "request_stateChanged";

        return {
            SetLoadingState: setLoadingState,
            RegisterOverlayListener: registerOverlayListeners,
            RegisterActionBarListener: registerActionBarListeners,
            GetStatus: () => current,
        };

        function setLoadingState(overlayLoadingStatus, actionBarLoadingStatus) {
            $rootScope.$broadcast(OVERLAY_KEY, overlayLoadingStatus);
            $rootScope.$broadcast(ACTION_BAR_KEY, actionBarLoadingStatus);

            current.actionBar = actionBarLoadingStatus;
            current.overlay = overlayLoadingStatus;

            // Until we fully migrate the users of $rootScope.$broadcast, also broadcast legacy event
            $rootScope.$broadcast(LEGACY_KEY, overlayLoadingStatus, actionBarLoadingStatus);
        }

        function registerOverlayListeners(callback) {
            if (!angular.isFunction(callback))
                console.error("registerOverlayListeners: Callback not provided");

            $rootScope.$on(OVERLAY_KEY, callback);
            //because the component is rendered after the parent controller is initialized we could lose information about the current status
            callback(null, current.overlay);
        }

        function registerActionBarListeners(callback) {
            if (!angular.isFunction(callback))
                console.error("registerActionBarListeners: Callback not provided");

            $rootScope.$on(ACTION_BAR_KEY, callback);
            //because the component is rendered after the parent controller is initialized we could lose information about the current status
            callback(null, current.actionBar);
        }
    }
})();